<template>
	<v-menu bottom offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				v-bind="attrs"
				v-on="on"
				height="32"
				class="font-12 font-weight-regular menu-btn select-btn little-select"
				color=""
				elevation="0"
				:loading="loading"
			>
				{{ selectedValue }}<v-icon class="ml-1">mdi-chevron-down</v-icon>
			</v-btn>
		</template>
		<v-list>
			<v-list-item v-for="(options, i) in options" v-bind:key="'item-' + i" link @click="setValue(options.value)" class="list-item subtitle-2 link" :class="{active: options.value == value}">
				{{ options.text }}
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	name: "LittleSelect",
	props: {
		options: {
			type: Array,
			default: function () {
				return [
					{
						value: "top",
						text: this.$vuetify.lang.t(
							"$vuetify.views.wall.filters.top"
						),
					},
					{
						value: "activity",
						text: this.$vuetify.lang.t(
							"$vuetify.views.wall.filters.activity"
						),
					},
					{
						value: "new",
						text: this.$vuetify.lang.t(
							"$vuetify.views.wall.filters.new"
						),
					},
					{
						value: "old",
						text: this.$vuetify.lang.t(
							"$vuetify.views.wall.filters.old"
						),
					},

				]
			}
		},
		value: {
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			filter: null
		}
	},
	computed: {
		selectedValue() {
			let valueObject = this.options.find(o => o.value === this.filter);
			if (valueObject) {
				return valueObject.text
			}
			return ''
		}
	},
	created() {
		if(this.value) {
			this.filter = this.value
		}
		else {
			this.filter = this.options[0].value
		}
	},
	methods: {
		setValue(val) {
			this.filter = val;
			this.$emit('selected', val)
		}
	}
}
</script>

<style lang="scss">
	.little-select {
		color:  var(--v-grey-darken2) !important;
		border: 1px solid var(--v-grey-lighten4) !important;
		border-radius: 8px !important;
		background-color: white !important;
		//border: 1px solid var(--v-grey-lighten4);
		box-shadow: 0px 3px 1px -2px var(--v-grey-lighten4), 0px 2px 2px 0px var(--v-grey-lighten4), 0px 1px 5px 0px var(--v-grey-lighten4) !important;
		//input {
		//	display: none;
		//}
		.active {
			color: var(--v-accent-base) !important;
		}
	}
	.v-list-item.active {
		color: var(--v-accent-base) !important;
	}
</style>
